import DOMPurify from 'dompurify';

// Allowed HTML for rich sermon content rendered in SharedSermon, PreachMode, Research
const SERMON_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: [
    'p', 'br', 'b', 'i', 'em', 'strong', 'u', 's', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'blockquote', 'span', 'div', 'a', 'sup', 'sub',
    'mark',
  ],
  // 'start' keeps continued numbered lists (<ol start="2">) from restarting at 1 in Preach Mode.
  ALLOWED_ATTR: ['class', 'data-type', 'data-section-id', 'href', 'target', 'rel', 'style', 'start'],
  ALLOW_DATA_ATTR: false,
  FORBID_SCRIPTS: true,
};

// Narrow config for plain-text-ish contexts (AI analysis blurbs, commentary snippets)
const PLAIN_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'em', 'strong', 'ul', 'ol', 'li', 'h2', 'h3', 'span'],
  ALLOWED_ATTR: ['class'],
  ALLOW_DATA_ATTR: false,
  FORBID_SCRIPTS: true,
};

export function sanitizeSermonHtml(html: string): string {
  return DOMPurify.sanitize(html, SERMON_CONFIG);
}

export function sanitizePlainHtml(html: string): string {
  return DOMPurify.sanitize(html, PLAIN_CONFIG);
}

/** Safe text extraction — no script execution risk unlike innerHTML assignment */
export function extractTextFromHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent ?? '';
}
